import {DeveloperMode, PhoneIphone, LocalMall, Google, Paid, Diamond} from '@mui/icons-material';
const sData = [
    {
        id: 1,
        icon : <Diamond className="sIcon"/>,
        service : "Website Designing",
        desc : "We build the modern websites with and creative design that results into very interactive user interface and it is fully responsive for all kind of devices such as desktop, tablets and mobile."
    },
    {
        id: 2,
        icon : <DeveloperMode className="sIcon"/>,
        service : "Website Devlopment",
        desc : "We build creative dynamic websites and web apps with very high standerd coding which are bug free and interact with front-end and database and also integrate third party apis."
    },
    {
        id: 3,
        icon : <PhoneIphone className="sIcon"/>,
        service : "Mobile App Devlopment",
        desc : "The increasing rate of mobile users. We develop cross-platform web apps that can be installed on mobile devices with the help of a web browser and provide your customers with instant online access."
    },
    {
        id: 4,
        icon : <Paid className="sIcon"/>,
        service : "Digital Marketing",
        desc : "We have an obsession with delivering the best SEM, SMM, SEO, e-commerce marketing, content marketing, and campaign marketing services to our clients. Keep your mind at ease by opting for our services."
    },
    {
        id: 5,
        icon : <LocalMall className="sIcon"/>,
        service : "E-Commerce Devlopment",
        desc : "Increase the reach of your products and services with our E-commerce Development services and be ready to receive tons of inquiries in your mailbox. E-commerce marketing is the best way to get rid of traditional marketing methods."
    },
    {
        id: 6,
        icon : <Google className="sIcon"/>,
        service : "Search Engine Optimization",
        desc : "With the best SEO strategy, we aim to bring your website to the top positions in Google and improve organic traffic. SEO helps to engage with potential customers, can drive valuable traffic to your website and increase revenue."
    }
]

export default sData